import React, { useState, useEffect, cloneElement } from "react";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";


import CloseIcon from "@material-ui/icons/Close";
import SaveIcon from "@material-ui/icons/Save";

import style from "./style.module.css";

const initialState = {
    data: null,
    error: null,
    primaryCallback: () => true,
    secondaryCallback: () => true,
};

export const Modal = (props) => {
    const [modalState, setModalState] = useState(initialState);

    const {
        isModalOpen,
        handleModalClose,
        children,
        modalProps: {
            modalLabels,
            primaryAction,
            secondaryAction,
            hideCtaIcons = false,
        },
        pushNotif,
    } = props;

    const {
        modalTitle,
        primaryText,
        secondaryText,
        showDividers = false,
    } = modalLabels || {};

    useEffect(() => {
        if (!isModalOpen) {
            setModalState(initialState);
        }
    }, [isModalOpen]);

    return (
        <Dialog
            onClose={handleModalClose}
            open={isModalOpen || false}
            PaperProps={{ className: style.root }}
        >
            {modalTitle ? (
                <div className={style.modalHeader}>
                    <div className={style.modalTitle}>{modalTitle}</div>
                    <div
                        aria-label="close"
                        className={style.closeButton}
                        onClick={handleModalClose}
                    >
                        &times;
                    </div>
                </div>
            ) : null}
            <DialogContent dividers={showDividers}>
                {children
                    ? cloneElement(children, {
                          modalState,
                          setModalState,
                          pushNotif,
                      })
                    : null}
            </DialogContent>
            <DialogActions>
                {primaryAction ? (
                    <Button
                        onClick={() => {
                            let valid = true;
                            if (
                                modalState?.primaryCallback &&
                                typeof modalState.primaryCallback === "function"
                            ) {
                                valid = modalState.primaryCallback(modalState);
                            }
                            if (valid) primaryAction(modalState);
                        }}
                        className={style.ctaButton}
                        variant="text"
                        color="primary"
                    >
                        {hideCtaIcons ? null : (
                            <>
                                <SaveIcon />
                                &nbsp;
                            </>
                        )}
                        {primaryText || "Save"}
                    </Button>
                ) : null}
                {secondaryAction ? (
                    <Button
                        onClick={() => {
                            let valid = true;
                            if (
                                modalState?.secondaryCallback &&
                                typeof modalState.secondaryCallback ===
                                    "function"
                            ) {
                                valid =
                                    modalState.secondaryCallback(modalState);
                            }
                            if (valid) secondaryAction(modalState);
                        }}
                        className={style.ctaButton}
                        variant="text"
                        color="secondary"
                    >
                        {hideCtaIcons ? null : (
                            <>
                                <CloseIcon />
                                &nbsp;
                            </>
                        )}
                        {secondaryText || "Close"}
                    </Button>
                ) : null}
            </DialogActions>
        </Dialog>
    );
};
